<template>
  <div class="cheat_income">
    <template-form
      :isBack="true"
      title="ลองยื่นรายได้ต่ำกว่าความจริง"
      description="แค่ลองเฉยๆนะ"
    >
      <div class="cib-answer">
        <div class="ciba-caption">แจ้งยอดรายได้กี่ % จากยอดจริง</div>
        <dropdown :options="options" v-model="total" placeholder="เลือก %" />
      </div>

      <div class="cib-header" v-bind:class="{ hidden: !show }">
        <div class="cibh-left">
          <div class="cibh-block">
            <img
              class="cibh-img"
              src="@/assets/icons/Single Neutral.svg"
              alt="Single Neutral"
            />
          </div>
          <h4>บุคคลธรรมดา <br /></h4>
          <span class="cibh-small">แจ้ง {{ total }}%</span>
        </div>
        <div class="cibh-right">
          <div class="cibh-block">
            <img
              class="cibh-img"
              src="@/assets/icons/Building Flag.svg"
              alt="Building Flag"
            />
          </div>
          <h4>นิติบุคคล</h4>
          <span class="cibh-small">แจ้ง {{ total }}%</span>
        </div>
      </div>

      <div class="ptcb-row" v-bind:class="{ hidden: !show }">
        <div class="ptcbr-topic">อัตราภาษี</div>
        <div class="ptcbr-detail">
          <div class="ptcbrd-left">
            {{ personal.cheat.maxTaxRate }}%
            <span class="ptcbrd-smalltext2">
              จากเดิม
              {{ personal.original.maxTaxRate }}%
            </span>
          </div>
          <div class="ptcbrd-right">
            {{ corporation.cheat.maxTaxRate }}%
            <span class="ptcbrd-smalltext2">
              จากเดิม {{ corporation.original.maxTaxRate }}%
            </span>
          </div>
        </div>
      </div>

      <div class="ptcb-row" v-bind:class="{ hidden: !show }">
        <div class="ptcbr-topic">ค่าภาษี</div>
        <div class="ptcbr-detail">
          <div class="ptcbrd-left">
            <currency mode="readOnly" v-model="personal.cheat.tax" />
            <span class="ptcbrd-smalltext2">
              จากเดิม
              <currency
                class="ptcbrd-smalltext2"
                mode="readOnly"
                v-model="personal.original.tax"
              />
            </span>
          </div>
          <div class="ptcbrd-right">
            <currency mode="readOnly" v-model="corporation.cheat.tax" />
            <span class="ptcbrd-smalltext2">
              จากเดิม<currency
                class="ptcbrd-smalltext2"
                mode="readOnly"
                v-model="corporation.original.tax"
              />
            </span>
          </div>
        </div>
      </div>

      <div class="ptcb-row" v-bind:class="{ hidden: !show }">
        <div class="ptcbr-topic">ค่าภาษี + เบี้ยปรับ</div>
        <div class="ptcbr-detail">
          <div class="ptcbrd-left">
            <currency
              class="ptcbrd-text-bold ptcbrd-error"
              mode="readOnly"
              v-model="personal.cheat.fined"
            />
            <span class="ptcbrd-lable">
              จากเดิม
              <currency
                class="ptcbrd-smalltext2"
                mode="readOnly"
                v-model="personal.original.fined"
              />
            </span>
          </div>
          <div class="ptcbrd-right">
            <currency
              class="ptcbrd-text-bold ptcbrd-error"
              mode="readOnly"
              v-model="corporation.cheat.fined"
            />
            <span class="ptcbrd-lable">
              จากเดิม
              <currency
                class="ptcbrd-smalltext2"
                mode="readOnly"
                v-model="corporation.original.fined"
              />
            </span>
          </div>
        </div>
      </div>

      <material-button
        class="cib-button"
        @clickButton="goToFinalDecision"
        v-bind:class="{ hidden: !show }"
      >
        ถัดไป
      </material-button>
      <material-button
        v-bind:class="{ hidden: show, disable: total > 0 }"
        :disabled="total == 0"
        class="cib-button"
        @clickButton="openModal"
      >
        ถัดไป
      </material-button>
    </template-form>
    <modal v-if="showModal">
      <div slot="body">
        <img :src="VECTOR" class="img-vector" />
        <div class="red bold" style="margin-bottom: 10px;">ถ้าคุณโดนตรวจพบ</div>
        <div style="margin-bottom: 10px;">
          คุณจะโดนค่าภาษี + เบี้ยปรับอย่างน้อยจำนวน
        </div>
        <div
          class="red center"
          v-if="corporation.cheat.fined < personal.cheat.fined"
        >
          {{ corporation.cheat.fined.toLocaleString("th-TH") }}
          บาท
        </div>
        <div class="red center" v-else>
          {{ personal.cheat.fined.toLocaleString("th-TH") }}
          บาท
        </div>
      </div>
      <div slot="footer">
        <material-button
          class="ptcb-button button-secondary"
          @clickButton="goNext()"
        >
          ปิด
        </material-button>
      </div>
    </modal>
    <StateAnswer />
  </div>
</template>

<script>
import StateAnswer from "@/components/StateAnswer.vue";
import * as taxPersonal from "@/helper/personal_tax_helper";
import * as taxCorperation from "@/helper/corporate_tax_helper";
import VECTOR from "@/assets/images/forms/vector-alert.png";
export default {
  name: "CheatIncome",
  components: {
    StateAnswer,
  },
  computed: {
    validate: function () {
      let valid = false;
      if (this.total > 0) {
        valid = true;
      }
      return valid;
    },
    personal: function () {
      const onlineSelling = this.$store.getters["taxInfo/getIncome"]
        .onlineSelling;
      const cost = this.$store.getters["taxInfo/getExpense"].cost;
      const totalIncomeOnlineSelling = onlineSelling * 12;

      const expense = {
        ...this.$store.getters["taxInfo/getFilterExpense"],
        cost,
      };

      const totalExpense = Object.values(expense).reduce(
        (sum, value) => sum + parseFloat(value) * 12,
        0
      );
      const salary = this.$store.getters["taxInfo/getIncome"].salary;
      const totalIncomeSalary = salary * 12;

      const deducts = this.$store.getters["taxInfo/getDeduct"];

      const cheat = taxPersonal.calculatePersonalTaxInfo({
        incomes: {
          onlineSelling: {
            income:
              totalIncomeOnlineSelling *
              (Math.max(0, parseFloat(this.total)) / 100),
            expense: totalExpense,
          },
          salary: {
            income:
              totalIncomeSalary * (Math.max(0, parseFloat(this.total)) / 100),
            expense: 0,
          },
        },
        deducts: deducts,
      });
      const original = taxPersonal.calculatePersonalTaxInfo({
        incomes: {
          onlineSelling: {
            income: totalIncomeOnlineSelling,
            expense: totalExpense,
          },
          salary: {
            income: totalIncomeSalary,
            expense: 0,
          },
        },
        deducts: deducts,
      });
      return {
        cheat: {
          maxTaxRate: cheat.maxTaxRate * 100,
          tax: cheat.tax,
          fined: parseFloat(
            original.tax + Math.abs(original.tax - cheat.tax) * 1.015
          ),
        },
        original: {
          maxTaxRate: original.maxTaxRate * 100,
          tax: original.tax,
          fined: original.tax,
        },
      };
    },
    corporation: function () {
      const onlineSelling = this.$store.getters["taxInfo/getIncome"]
        .onlineSelling;
      const salary = this.$store.getters["taxInfo/getIncome"].salary;

      const totalIncomeOnlineSelling = onlineSelling * 12;
      const totalIncomeSalary = salary * 12;

      const cost = this.$store.getters["taxInfo/getExpense"].cost;

      const expense = {
        ...this.$store.getters["taxInfo/getFilterExpense"],
        cost,
      };

      const totalExpense = Object.values(expense).reduce(
        (sum, value) => sum + parseFloat(value) * 12,
        0
      );

      const cheat = taxCorperation.calculateCorporateTaxInfo({
        incomes: {
          onlineSelling: {
            income:
              totalIncomeOnlineSelling *
              (Math.max(0, parseFloat(this.total)) / 100),
            expense: totalExpense,
          },
          salary: {
            income:
              totalIncomeSalary * (Math.max(0, parseFloat(this.total)) / 100),
            expense: 0,
          },
        },
      });
      const original = taxCorperation.calculateCorporateTaxInfo({
        incomes: {
          onlineSelling: {
            income: totalIncomeOnlineSelling,
            expense: totalExpense,
          },
          salary: {
            income: totalIncomeSalary,
            expense: 0,
          },
        },
      });
      return {
        cheat: {
          maxTaxRate: cheat.maxTaxRate * 100,
          tax: cheat.tax,
          fined: parseFloat(
            original.tax + Math.abs(original.tax - cheat.tax) * 1.015
          ),
        },
        original: {
          maxTaxRate: original.maxTaxRate * 100,
          tax: original.tax,
          fined: original.tax,
        },
      };
    },
  },
  data() {
    return {
      VECTOR,
      total: 0,
      show: false,
      showModal: false,
      options: [
        { lable: "25%", value: 25 },
        { lable: "50%", value: 50 },
        { lable: "75%", value: 75 },
        { lable: "90%", value: 90 },
      ],
    };
  },
  methods: {
    goToFinalDecision() {
      this.$router.push({
        path: "/questions/final_decision",
      });
    },
    openModal() {
      this.showModal = true;
    },
    goNext() {
      this.showModal = false;
      this.show = true;
    },
  },
};
</script>

<style scoped>
.cheat_income {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.ci-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  text-align: center;
  position: relative;
  margin-top: 34px;
  margin-bottom: 26px;

  max-width: 351px;
}
.disabled {
  color: #b5b6bf;
  pointer-events: none;
  cursor: default;
}
.cib-title {
  width: 100%;
  border-bottom: 1px solid #acb1bf;
  margin-bottom: 24px;
  padding-bottom: 16px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  text-align: left;
}
.cib-answer {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  text-align: left;
  width: 100%;
  max-width: 352px;
}
.ciba-caption {
  display: flex;
}
.ciba-caption > span {
  color: #acb1bf;
  margin-left: 6px;
}
.ciba-input {
  height: 24px;
  width: 320px;
  padding: 15px 16px;
  border-radius: 5px;
  border: 1px solid #acb1bf;
}

.cib-header {
  width: 100%;
  display: flex;
  margin-bottom: 48px;
  margin-top: 40px;
}
.cibh-block {
  border-radius: 2px;
}
.cibh-left {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  margin-right: 7px;
}
.cibh-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  margin-left: 7px;
}
.cibh-img {
  width: 40px;
  height: 40px;
}
.cibh-small {
  font-size: 12px;
}

.ptcb-row {
  width: 100%;
  max-width: 351px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 24px;
}
.ptcbr-topic {
  width: 100%;
  display: flex;
  align-items: center;
  text-align: left;
  color: #acb1bf;
  border-bottom: 1px solid #d8d9e0;
  margin-bottom: 8px;
}
.ptcbr-detail {
  width: 100%;
  display: flex;
}
.ptcbr-detail > div {
  flex: 1;
  text-align: right;
  display: flex;
  flex-direction: column;
}
.ptcbrd-left {
}
.ptcbrd-right {
}
.ptcbrd-text-bold {
  font-weight: bold;
}
.ptcbrd-error {
  color: #f45a49 !important;
}
.ptcbrd-wrap {
  display: flex;
}
.ptcbrd-lable {
  font-size: 12px;
  color: #acb1bf !important;
}
.ptcbrd-smalltext2 {
  font-size: 12px;
  color: #acb1bf !important;
}

.ci-footer .crl-link {
  justify-content: flex-end;
}

.cib-button {
  max-width: 352px;
  margin: 40px 0;
}
.img-vector {
  margin-bottom: 20px;
}
.red {
  color: #f45a49;
  font-weight: bold;
  font-size: 23px;
}
.bold {
  font-weight: bold;
}
.hidden {
  display: none;
}
.center {
  display: flex;
  justify-content: center;
}
@media only screen and (min-width: 769px) {
  .cib-header,
  .ptcb-row {
    max-width: 544px;
  }
}
</style>
